// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3j1nH","productName":"Table_productName__2u4Za"};